const Cart = {

    // FIELDS
    "search": "Search",

    // PAGE HEADER
    "cart": "Cart",

    // TABLE HEADER
    "table_user": "USER",
    "table_email": "EMAIL",
    "table_mobile": "MOBILE",
    "table_product": "PRODUCT",
    "table_variant": "VARIANT",
    "table_quantity": "QUANTITY",
    "table_price": "PRICE",
    "table_added_on": "ADDED ON",

}

export default Cart;